import React, { createContext, useState, useEffect } from 'react';
import '../i18next';
import { useTranslation } from 'react-i18next';

export const GlobalCtx = createContext();

// language mapping - some values are normalized to others
const normalizeLang = (lang) => {
  if (!lang) return 'en-row'; // Default language if lang is undefined/null
  const langMap = {
    'pl-pl': 'pl',
    'hu-hu': 'hu',
    'hr-hr': 'hr',
    'it-it': 'it',
    'nl-nl': 'nl',
    'tl-ph': 'tl',
    'sk-sk': 'sk',
    'de-de': 'de',
    'es-ho': 'hazteoir',
    'vls-be': 'nl-be',
    'es-row': 'es-lat'
    // Add more mappings in the future
  };
  return langMap[lang] || lang;
};

const GlobalContext = ({ children }) => {
  const { i18n } = useTranslation();
  const [normalizedLang, setNormalizedLang] = useState(i18n.language);
  const [originalLang, setOriginalLang] = useState(i18n.language);
  
  useEffect(() => {
    // Safe language retrieval with fallback
    const getLanguage = () => {
      if (i18n.language) return i18n.language;
      const fallback = i18n.options?.fallbackLng;
      if (typeof fallback === 'string') return fallback;
      if (typeof fallback === 'object' && fallback?.default) return fallback.default;
      return 'en-row';
    };
    
    const language = getLanguage();
    const normalized = normalizeLang(language);
    setNormalizedLang(normalized);
    setOriginalLang(language);
  }, [i18n.language, i18n.options?.fallbackLng]);

  return (
    <GlobalCtx.Provider value={{
      lang: normalizedLang,
      originalLang: originalLang
    }} >
      {children}
    </GlobalCtx.Provider>
  );
};

export default GlobalContext;
